import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
import i18n from './i18n'

export default new Vuex.Store({
    state: {
        categories: null,
        articles: null,
    },
    
    getters: {
        getSupportCategories: state => {
            if (state.categories) {
                return state.categories;
            }
            return;
        },
        getSupportArticles: state => {
            if (state.articles) {
                return state.articles;
            }
            return;
        },
    },
    
    mutations: {
        setCategories(state, categories){
            state.categories = categories;
        },
        setArticles(state, articles){
            state.articles = articles;
        },
    },
    
    actions: {
		async listSupportCategories(context){
			// if (localStorage.categories != 'undefined') {
			// 	this.commit('setCategories', JSON.parse(localStorage.categories));
			// 	return JSON.parse(localStorage.categories);
			// }
			
			const contentful = require('contentful');
			
			const client = contentful.createClient({
				space: process.env.VUE_APP_BLOG_SPACE_ID,
				accessToken: process.env.VUE_APP_BLOG_ACCESS_TOKEN,
			});
			
			const response = await client.getEntries({
				content_type: 'category',
				locale: 'en-US',
			});
			
			if (response) {
				let responseFiltered = response;
				
				responseFiltered.items = responseFiltered.items.filter(c => {
					if ( c.metadata?.tags?.length && c.metadata?.tags.find( tag => tag.sys.id == 'partnerPortal')){
						//  && [0].sys?.id == 'partnerPortal' 
						return false;
					}
					else {
						return true;
					}
				});
				
				// localStorage.categories = JSON.stringify( response );
				this.commit('setCategories', responseFiltered);
				return responseFiltered;
			}
		},
		
		async listSupportArticles(context){
			// if (localStorage.articles != 'undefined') {
			// 	this.commit('setArticles', JSON.parse(localStorage.articles));
			// 	return JSON.parse(localStorage.articles);
			// }
			
			const contentful = require('contentful');
			
			const client = contentful.createClient({
				space: process.env.VUE_APP_BLOG_SPACE_ID,
				accessToken: process.env.VUE_APP_BLOG_ACCESS_TOKEN,
			});
			
			const response = await client.getEntries({
				content_type: 'article',
				locale: 'en-US',
			});
			
			if (response) {
				// localStorage.articles = JSON.stringify( response );
				this.commit('setArticles', response);
				return response;
			}
		},
		
    }
})
